import React, { useEffect, useState } from 'react';
import axios from 'axios';

import servicesApi from '../../seller-apis/servicesApi';
import api from '../../seller-apis/api';
import BrandDropDown from './BrandDropDown';
import FileUploader from './FileUploader';
import Button from './Button';
import './brand.css';
import { Modal } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import Loader from '../common/Loader';
import convertFileToWebP from '../../utilities/convertFileToWebP';

const UPLOAD_TRADEMAKE_CERTIFICATE = "*Upload Trademark Certificate";
const IN_PDF_JPEG_FORMAT = "(in PDF or JPEG Format)";
const UPLOAD_REGISTERED_LOGO = "*Upload Registered Logo";
const MAX_SIZE_500_KB = "(Max Size 500 Kb)";
const ENTER_YOUR_BRAND_NAME = "*Select Brand";
const TYPE_YOUR_BRAND_NAME = "*Type your Brand Name";
const TNC_FIRST = "By continuing, I agree to Toolsvilla";
const TNC_SECOND = "Terms of Use & Privacy Policy";
const REGISTER_BUTTON = "Register & Continue";
const REQUIRED = "*Required";

function Brands() {

    const [loader, setLoader] = useState(true)

    const history = useHistory()
    useEffect(() => {
        fetchBrands()
    }, [])


    const fetchBrands = async () => {
        try{
            const res = await api.TradeMark.sellerTradeMark({ "pageNo": 1,
                "size": 1});
                if(res?.data?.totalRecords > 0){
                    history.push('/apply-brand/1')
                }
        }catch(err){
            console.log(err)
        }finally{
            setLoader(false)
        }
    }
    if(loader){
        return <></>
    }
    return (
        <div>
            <div className='container'>

                <div className='row mb-5 mt-5 f-c-r'>
                    <div className='col-md-7 col-xs-12 col-sm-12 mt-4'>
                        <div className='brand-heading'>Promote your Brands and Products with your own store on Toolsvilla.</div>
                        <div className='brand-get-started mt-4'>
                            <button onClick={() => history.push('/apply-brand/1')}>Get Started <i className="bi bi-arrow-right"></i></button>
                        </div>
                        <div className='brand-features'>
                            <div className='brand-feature-box'>
                                <img src='/brand/gs-1.png' alt="Get Started" height={50} />
                                <p>Exclusive</p>
                                <p>Selling rights</p>
                            </div>
                            <div className='brand-feature-box'>
                                <img src='/brand/gs-2.png' alt="Get Started" height={50} />
                                <p>Brand</p>
                                <p>Protection</p>
                            </div>
                            <div className='brand-feature-box'>
                                <img src='/tv_badge.png' alt="Get Started" height={50} />
                                <p>Toolsvilla</p>
                                <p>Trust Badge</p>
                            </div>
                            <div className='brand-feature-box'>
                                <img src='/brand/gs-3.png' alt="Get Started" height={50} />
                                <p>Priority</p>
                                <p>Support</p>
                            </div>
                            <div className='brand-feature-box'>
                                <img src='/brand/gs-4.png' alt="Get Started" height={50} />
                                <p>Brand</p>
                                <p>ADS</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-5 col-xs-12 col-sm-12 offset-1 m-sm-0'>
                        <img src='/brand/banner.webp' alt="Brand Banner" className='w-sm-100' height={400} width="98%"/>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default Brands;